import { render, staticRenderFns } from "./CustomVueEditor.vue?vue&type=template&id=3bdad41e&scoped=true"
import script from "./CustomVueEditor.vue?vue&type=script&lang=js"
export * from "./CustomVueEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomVueEditor.vue?vue&type=style&index=0&id=3bdad41e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdad41e",
  null
  
)

export default component.exports